export enum GraphExportStatus {
  REQUESTED = "requested",
  PROCESSING = "processing",
  READY = "ready"
}

export type GraphExportReadyResponse = {
  status: GraphExportStatus.READY;
  downloadUrl: string;
};

export type GraphExportPendingResponse = {
  status: GraphExportStatus.PROCESSING | GraphExportStatus.REQUESTED;
};

export type GetGraphExportResponse = GraphExportReadyResponse | GraphExportPendingResponse;
